import { getGrpcPromise } from '@monorepo/grpc';
import { PricingService } from '@spilca/order_ts/v1/order_web/pricing_web_pb_service';
import { ListPricingBrandRequest } from '@spilca/order_ts/v1/order/model_pricing_pb';
import { pricingFilterConstructor } from '@monorepo/pricing';

const getPricingBrands = (d: any) => {
  const [, params] = d.queryKey;
  const getBrands = getGrpcPromise(PricingService.ListPricingBrand);
  const dealFilter = pricingFilterConstructor(params, d.active);
  const request = new ListPricingBrandRequest();
  request.setFilter(dealFilter);
  return getBrands(request);
};

export default getPricingBrands;
